import { useEffect, useRef, useState } from 'react';
import { placarEquipe } from '../montagem';
import type { EquipePlacar } from '../types';

interface Props {
  jaEstaEmEquipe: boolean;
  equipes: EquipePlacar[];
  aoEscolher: (equipeId: number) => void;
}

export default function SeletorAlocar({ jaEstaEmEquipe, equipes, aoEscolher }: Props) {
  const [aberto, setAberto] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!aberto) return;
    function aoClicarFora(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setAberto(false);
    }
    document.addEventListener('mousedown', aoClicarFora);
    return () => document.removeEventListener('mousedown', aoClicarFora);
  }, [aberto]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setAberto((v) => !v)}
        className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-secondary-300 bg-white px-2.5 py-1.5 text-xs font-medium text-foreground-800 transition-colors hover:bg-background-100"
      >
        {jaEstaEmEquipe ? 'mover para…' : 'colocar em…'}
        <i className="ri-arrow-down-s-line text-sm text-secondary-500" />
      </button>

      {aberto && (
        <div className="absolute right-0 top-full z-30 mt-1 max-h-72 w-56 overflow-y-auto rounded-md border border-secondary-200 bg-white py-1">
          {equipes.map((e) => (
            <button
              key={e.equipe_id}
              type="button"
              onClick={() => {
                setAberto(false);
                aoEscolher(e.equipe_id);
              }}
              className="flex w-full cursor-pointer items-center justify-between gap-2 whitespace-nowrap px-3 py-2 text-left text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <span className="truncate">{placarEquipe(e)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}